module.exports = "https://trybtryb-legacy.web.app/img/pastel-pines.b372cd48.webp";